import { createAsyncThunk } from '@reduxjs/toolkit';
import costsClaimApi from 'api/costsClaimApi';
import { actions } from './costsClaimSlice';
import { notificationToast } from 'components/notificationToast';
import { Notification } from 'constants/notification';

export const getMyClaims = createAsyncThunk(
  'costsClaim/getMyClaims',
  async (params: any, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.getMyClaimsRaw(params);
      thunkApi.dispatch(actions.setMyClaims(res));
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Không thể tải danh sách claim',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const getAllClaims = createAsyncThunk(
  'costsClaim/getAllClaims',
  async (params: any, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.getAllClaims(params);
      thunkApi.dispatch(actions.setAllClaims(res));
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Không thể tải tất cả claim',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const getClaimDetail = createAsyncThunk(
  'costsClaim/getClaimDetail',
  async (id: number, thunkApi) => {
    try {
      const res: any = await costsClaimApi.getClaimDetail(id);
      thunkApi.dispatch(actions.setCurrentClaim(res?.data));
      return res?.data;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Lỗi khi lấy chi tiết claim',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    }
  },
);

export const createClaim = createAsyncThunk(
  'costsClaim/createClaim',
  async (body: any, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.createClaim(body);
      notificationToast(
        Notification.Type.Success,
        'Tạo claim thành công',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Tạo claim thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const updateClaim = createAsyncThunk(
  'costsClaim/updateClaim',
  async ({ id, body }: { id: number; body: any }, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.updateClaim(id, body);
      notificationToast(
        Notification.Type.Success,
        'Cập nhật claim thành công',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Cập nhật claim thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const submitClaim = createAsyncThunk(
  'costsClaim/submitClaim',
  async (id: number, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.submitClaim(id);
      notificationToast(
        Notification.Type.Success,
        'Đã nộp claim thành công',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Nộp claim thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const cancelClaim = createAsyncThunk(
  'costsClaim/cancelClaim',
  async (id: number, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.cancelClaim(id);
      notificationToast(Notification.Type.Success, 'Đã hủy claim', Notification.Duration._3s);
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Hủy claim thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const approverDecision = createAsyncThunk(
  'costsClaim/approverDecision',
  async ({ id, body }: { id: number; body: any }, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.approverDecision(id, body);
      notificationToast(
        Notification.Type.Success,
        'Đã xử lý duyệt cấp 1',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Xử lý thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const financeDecision = createAsyncThunk(
  'costsClaim/financeDecision',
  async ({ id, body }: { id: number; body: any }, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.financeDecision(id, body);
      notificationToast(
        Notification.Type.Success,
        'Đã xử lý duyệt Finance',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Xử lý thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

export const markPaid = createAsyncThunk(
  'costsClaim/markPaid',
  async ({ id, body }: { id: number; body: any }, thunkApi) => {
    try {
      thunkApi.dispatch(actions.setLoading(true));
      const res: any = await costsClaimApi.markPaid(id, body);
      notificationToast(
        Notification.Type.Success,
        'Xác nhận thanh toán thành công',
        Notification.Duration._3s,
      );
      return res;
    } catch (err: any) {
      notificationToast(
        Notification.Type.Error,
        err?.message || 'Xác nhận thanh toán thất bại',
        Notification.Duration._3s,
      );
      return thunkApi.rejectWithValue(err);
    } finally {
      thunkApi.dispatch(actions.setLoading(false));
    }
  },
);

const DEFAULT_EXPENSE_TYPES = [
  {
    id: 1,
    code: 'CLOUD_SERVER',
    nameVi: 'Cloud & Server (AWS, GCP, Vercel...)',
    nameEn: 'Cloud Infrastructure & Hosting',
  },
  {
    id: 2,
    code: 'DEV_TOOL',
    nameVi: 'Bản quyền Phần mềm & Tool Dev (JetBrains, OpenAI...)',
    nameEn: 'Software License & Tools',
  },
  {
    id: 3,
    code: 'TRAVEL',
    nameVi: 'Công tác phí & Di chuyển (Taxi, Máy bay...)',
    nameEn: 'Travel & Transportation',
  },
  {
    id: 4,
    code: 'TEAM_BUILDING',
    nameVi: 'Hoạt động Team Building & Tiếp khách',
    nameEn: 'Team Building & Entertainment',
  },
  {
    id: 5,
    code: 'OFFICE_SUPPLIES',
    nameVi: 'Văn phòng phẩm & Thiết bị làm việc',
    nameEn: 'Office Supplies & Equipment',
  },
];

const DEFAULT_PAYMENT_METHODS = [
  { id: 1, code: 'BANK_TRANSFER', nameVi: 'Chuyển khoản ngân hàng', nameEn: 'Bank Transfer' },
  { id: 2, code: 'CASH', nameVi: 'Tiền mặt', nameEn: 'Cash' },
];

const DEFAULT_BANKS = [
  { id: 1, code: 'VCB', name: 'Ngân hàng TMCP Ngoại thương Việt Nam (Vietcombank)' },
  { id: 2, code: 'TCB', name: 'Ngân hàng TMCP Kỹ thương Việt Nam (Techcombank)' },
  { id: 3, code: 'MB', name: 'Ngân hàng TMCP Quân đội (MB Bank)' },
  { id: 4, code: 'ACB', name: 'Ngân hàng TMCP Á Châu (ACB)' },
  { id: 5, code: 'BIDV', name: 'Ngân hàng TMCP Đầu tư và Phát triển Việt Nam (BIDV)' },
  { id: 6, code: 'CTG', name: 'Ngân hàng TMCP Công Thương Việt Nam (VietinBank)' },
];

export const fetchMasterData = createAsyncThunk(
  'costsClaim/fetchMasterData',
  async (_, thunkApi) => {
    try {
      const [etRes, pmRes, bankRes]: any[] = await Promise.all([
        costsClaimApi.getExpenseTypes(true).catch(() => null),
        costsClaimApi.getPaymentMethods(true).catch(() => null),
        costsClaimApi.getBanks(true).catch(() => null),
      ]);

      const expenseTypes =
        etRes?.data && etRes.data.length > 0 ? etRes.data : DEFAULT_EXPENSE_TYPES;
      const paymentMethods =
        pmRes?.data && pmRes.data.length > 0 ? pmRes.data : DEFAULT_PAYMENT_METHODS;
      const banks = bankRes?.data && bankRes.data.length > 0 ? bankRes.data : DEFAULT_BANKS;

      thunkApi.dispatch(actions.setExpenseTypes(expenseTypes));
      thunkApi.dispatch(actions.setPaymentMethods(paymentMethods));
      thunkApi.dispatch(actions.setBanks(banks));
    } catch (err: any) {
      thunkApi.dispatch(actions.setExpenseTypes(DEFAULT_EXPENSE_TYPES));
      thunkApi.dispatch(actions.setPaymentMethods(DEFAULT_PAYMENT_METHODS));
      thunkApi.dispatch(actions.setBanks(DEFAULT_BANKS));
    }
  },
);
